/**
 * Product FAQ Accordion Component
 * Requirements: 10.4
 * 
 * @package MentoriaLeiSeca
 */

/**
 * Initialize FAQ accordion functionality
 * Requirement 10.4: Toggle de expansão ao clicar na pergunta,
 * colapsar outras perguntas ao expandir uma, alternar ícone plus/minus
 */
export function initProductFaq() {
    const faqSection = document.querySelector('.product-faq');
    if (!faqSection) {
        return;
    }

    const faqItems = faqSection.querySelectorAll('.product-faq__item');
    const faqQuestions = Array.from(faqSection.querySelectorAll('.product-faq__question'));

    if (faqQuestions.length === 0) {
        return;
    }

    // Add click handlers to all questions
    faqQuestions.forEach(function(question) {
        // Remove any existing onclick attribute
        question.removeAttribute('onclick');
        
        question.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            
            const item = question.closest('.product-faq__item');
            if (!item) {return;}

            const isOpen = item.classList.contains('product-faq__item--open');
            const answer = item.querySelector('.product-faq__answer');

            // Requirement 10.4: Colapsar outras perguntas ao expandir uma
            closeAllFaqItems(faqItems);

            // Toggle current item if it was closed
            if (!isOpen) {
                openFaqItem(item, question, answer);
            }
        });

        // Keyboard accessibility
        question.addEventListener('keydown', function(e) {
            const currentIndex = faqQuestions.indexOf(question);

            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                question.click();
                return;
            }

            if (e.key === 'ArrowDown') {
                e.preventDefault();
                const nextIndex = (currentIndex + 1) % faqQuestions.length;
                faqQuestions[nextIndex].focus();
            }

            if (e.key === 'ArrowUp') {
                e.preventDefault();
                const prevIndex = (currentIndex - 1 + faqQuestions.length) % faqQuestions.length;
                faqQuestions[prevIndex].focus();
            }

            if (e.key === 'Home') {
                e.preventDefault();
                faqQuestions[0].focus();
            }

            if (e.key === 'End') {
                e.preventDefault();
                faqQuestions[faqQuestions.length - 1].focus();
            }
        });
    });
}

/**
 * Close all FAQ items (animação controlada por CSS)
 * @param {NodeList} items - All FAQ items
 */
function closeAllFaqItems(items) {
    items.forEach(function(item) {
        const question = item.querySelector('.product-faq__question');
        const answer = item.querySelector('.product-faq__answer');
        
        item.classList.remove('product-faq__item--open');
        
        if (question) {
            question.setAttribute('aria-expanded', 'false');
        }

        if (answer) {
            answer.hidden = true;
        }
    });
}

/**
 * Open a specific FAQ item (animação controlada por CSS)
 * @param {HTMLElement} item - The FAQ item container
 * @param {HTMLElement} question - The question button
 * @param {HTMLElement} answer - The answer panel
 */
function openFaqItem(item, question, answer) {
    item.classList.add('product-faq__item--open');
    
    if (question) {
        question.setAttribute('aria-expanded', 'true');
    }

    if (answer) {
        answer.hidden = false;
    }
}

/**
 * Toggle FAQ item by index (for inline PHP usage)
 * @param {number} idx - Index of the FAQ item
 */
export function toggleFaqByIndex(idx) {
    const item = document.querySelector('[data-faq-item="' + idx + '"]');
    if (!item) {return;}

    const faqItems = document.querySelectorAll('.product-faq__item');
    const question = item.querySelector('.product-faq__question');
    const answer = item.querySelector('.product-faq__answer');
    const isOpen = item.classList.contains('product-faq__item--open');

    // Close all items
    closeAllFaqItems(faqItems);

    // Toggle current if it was closed
    if (!isOpen) {
        openFaqItem(item, question, answer);
    }
}

// Default export
export default initProductFaq;
